import { getSpaceBlogPost } from '@/lib/content';
import PageMeta from '@/shared/components/PageMeta';
import NotFoundPage from '@/pages/NotFoundPage';
import Markdown from '@/shared/components/Markdown';
import { useLanguage } from '@/shared/contexts/LanguageContext';
import { formatDate } from '@/shared/utils/i18n';
import { ArrowLeft, Calendar } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';

export default function BlogDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const { language, t } = useLanguage();

  const post = slug ? getSpaceBlogPost(slug, language) : undefined;

  if (!post) {
    return <NotFoundPage />;
  }

  return (
    <div className="pt-24 px-6">
      <PageMeta title={post.meta.title} description={post.meta.summary} path={`/space/blog/${post.slug}`} />
      <article className="max-w-3xl mx-auto space-y-8">
        <div>
          <Link
            to="/space/blog"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('backToBlog')}
          </Link>

          <h1 className="text-3xl md:text-4xl font-bold mb-4">{post.meta.title}</h1>
          <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
            <span className="inline-flex items-center gap-1.5">
              <Calendar className="w-3.5 h-3.5" />
              {formatDate(post.meta.date, language)}
            </span>
            {post.meta.category && <span>{post.meta.category}</span>}
            {post.meta.tags.map(tag => (
              <span
                key={tag}
                className="px-2 py-0.5 rounded-md text-xs bg-muted/40 border border-border/30"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        <Markdown>{post.body}</Markdown>
      </article>
    </div>
  );
}
